export default __webpack_public_path__ + "static/media/positionCategories.6197524b.png";